module.exports = __webpack_public_path__ + "static/media/1000072.ec1d842d.png";